import { Bell, Camera, CheckCircle2, Loader2, Mic, X } from "lucide-react";
import {
  permissionOptions,
  type PermissionsStepProps,
} from "./welcome-onboarding-types";

const icons = {
  camera: Camera,
  microphone: Mic,
  notifications: Bell,
};

export function WelcomePermissionsStep({
  busy,
  isBusy,
  onContinue,
  onRequest,
  onSkip,
  statuses,
}: PermissionsStepProps) {
  const isComplete = permissionOptions.every((item) => statuses[item.id]);
  return (
    <section
      className="welcome-onboarding__panel welcome-onboarding__panel--stack"
      aria-label="Permission setup"
    >
      <div className="welcome-onboarding__note">
        <strong>Ask once.</strong>
        <span>Skipped access can be enabled later from Settings.</span>
      </div>
      <div className="welcome-onboarding__permission-list">
        {permissionOptions.map((item) => {
          const Icon = icons[item.id];
          const status = statuses[item.id];
          return (
            <article className="welcome-onboarding__choice" key={item.id}>
              <Icon size={17} strokeWidth={1.8} />
              <div>
                <h2>{item.label}</h2>
                <p>{item.reason}</p>
              </div>
              <div className="welcome-onboarding__choice-actions">
                {status ? (
                  <span className="welcome-onboarding__mini-status">
                    {status === "granted" ? (
                      <CheckCircle2 size={14} />
                    ) : (
                      <X size={14} />
                    )}
                    {status}
                  </span>
                ) : (
                  <>
                    <button
                      className="welcome-onboarding__btn"
                      disabled={isBusy}
                      onClick={() => onRequest(item.id)}
                      type="button"
                    >
                      Enable
                    </button>
                    <button
                      className="welcome-onboarding__btn welcome-onboarding__btn--quiet"
                      disabled={isBusy}
                      onClick={() => onSkip(item.id)}
                      type="button"
                    >
                      Skip
                    </button>
                  </>
                )}
              </div>
            </article>
          );
        })}
      </div>
      <button
        className="welcome-onboarding__btn welcome-onboarding__btn--primary"
        disabled={isBusy || !isComplete}
        onClick={onContinue}
        type="button"
      >
        {busy === "saving" ? (
          <Loader2 size={16} strokeWidth={2.1} className="spin" />
        ) : null}
        <span>Continue</span>
      </button>
    </section>
  );
}
